import { HttpErrorResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { User } from "@domains/user";
import { UserEndpointService } from "@http-services/user";
import { Actions, createEffect, CreateEffectMetadata, ofType } from "@ngrx/effects";
import { catchError, forkJoin, map, of, switchMap } from "rxjs";
import { LOAD_USER, loadUserFailure, loadUserSuccess } from "./user.actions";

@Injectable()
export class UserEffects {
	private readonly actions$ = inject(Actions);
	private readonly userEndpointService = inject(UserEndpointService);

	public loadUser$: CreateEffectMetadata = createEffect(() =>
		this.actions$.pipe(
			ofType(LOAD_USER),
			switchMap(() =>
				forkJoin({
					claims: this.userEndpointService.getUser(),
					profile: this.userEndpointService.getUserDetails()
				}).pipe(
					map(({ claims, profile }) => {
						const user = new User(
							profile.userId,
							profile.firstName,
							profile.lastName,
							profile.emailAddress,
							claims.logoutUrl
						);
						return loadUserSuccess({ user });
					}),
					catchError((error: HttpErrorResponse) => of(loadUserFailure({ error })))
				)
			)
		)
	);
}
